/* MOREOVER PDP V3 mobile sticky Add to Bag */
(function () {
  if (window.__mrvrPdpV3Loaded) return;
  window.__mrvrPdpV3Loaded = true;

  var observer = null;
  var mutationObserver = null;
  var originalButton = null;
  var productInfo = null;
  var originalVisible = true;

  function removeBar() {
    var existing = document.getElementById('MrvrMobileATB');
    if (existing) existing.remove();
    if (observer) observer.disconnect();
    if (mutationObserver) mutationObserver.disconnect();
    observer = null;
    mutationObserver = null;
    originalButton = null;
    productInfo = null;
  }

  function init() {
    removeBar();
    productInfo = document.querySelector('product-info[id^="MainProduct-"]');
    if (!productInfo) return;
    originalButton = productInfo.querySelector('.product-form__submit');
    if (!originalButton) return;

    var bar = document.createElement('div');
    bar.id = 'MrvrMobileATB';
    bar.className = 'mrvr-mobile-atb';
    bar.innerHTML = '<button type="button" class="mrvr-mobile-atb__button"></button>';
    document.body.appendChild(bar);
    var button = bar.querySelector('button');

    function sync() {
      if (!originalButton || !originalButton.isConnected) return;
      var label = originalButton.querySelector('span');
      button.textContent = label ? label.textContent.trim() : (document.documentElement.lang === 'ar' ? 'أضف إلى السلة' : 'ADD TO BAG');
      button.disabled = originalButton.disabled;
    }

    function updateVisibility() {
      if (!productInfo || !productInfo.isConnected) return;
      var rect = productInfo.getBoundingClientRect();
      var withinProduct = rect.bottom > 0 && rect.top < window.innerHeight;
      var mobile = window.matchMedia('(max-width: 749px)').matches;
      bar.classList.toggle('is-visible', mobile && withinProduct && !originalVisible);
    }

    button.addEventListener('click', function () {
      if (!originalButton || originalButton.disabled) return;
      originalButton.click();
    });

    observer = new IntersectionObserver(function (entries) {
      originalVisible = entries[0] ? entries[0].isIntersecting : true;
      updateVisibility();
    }, { threshold: 0.15 });
    observer.observe(originalButton);

    mutationObserver = new MutationObserver(sync);
    mutationObserver.observe(originalButton, { attributes: true, childList: true, subtree: true, characterData: true });

    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility, { passive: true });
    sync();
    updateVisibility();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', removeBar);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();